import React from 'react';
import PropTypes from 'prop-types';
import { REPORT_ONLY_LAYOUT } from '../../constants/reportLayouts';
import ReportLayoutPage from './ReportLayoutPage'


const ReportOnlyLayout = ({ match }) => (
  <ReportLayoutPage
    layout={REPORT_ONLY_LAYOUT}
    reportType={match.params.type}
    companyId={match.params.companyId}
    withCoverLetter={false}
    withEndOfReport={true}
    withAttachment={true}
  />
);

ReportOnlyLayout.propTypes = {
  match: PropTypes.object
};

export default ReportOnlyLayout;


// WEBPACK FOOTER //
// src/components/reportLayout/ReportOnlyLayout.jsx